export const MENU_REQUESTED = "MENU_REQUESTED";
export const MENU_RECEIVED = "MENU_RECEIVED";
export const MENU_REQUEST_FAILED = "MENU_REQUEST_FAILED";

export const requestMenu = () => ({ type: MENU_REQUESTED });
export const receiveMenu = items => ({ type: MENU_RECEIVED, payload: { items } });
